import { InMemoryCache } from '@apollo/client';
import { generated } from '@lingoda/monolith-graphql';
import { typePolicies } from './typePolicies';

export const getGraphQLCache = () =>
    new InMemoryCache({
        typePolicies,
        possibleTypes: generated.possibleTypes,
    });
